import './socialAuth.css';
export default function AboutLink({ onClick }) {
    return <a className="lv-about-link" href="https://lovirds.ru/" target="_blank" rel="noopener noreferrer" onClick={onClick}>
        О нас <span aria-hidden="true">↗</span>
    </a>;
}
